export default __webpack_public_path__ + "media/images/icons_fc/cashier-bb3b8d5cc5285b7af9f94b4a71c4024f.png";